
import { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ThankYouContent } from "../../components/thankyoucontent/thankyoucontent";
import {
  NotificationManager,
} from "react-notifications";
import aiTestRating from "../../apis/aiTestRating/aiTestRating";
import { UserTypeContext } from "../../AppRoute";



export function ThankYouPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { userRecruitmentpartnerId } = useContext(UserTypeContext);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const recruiterPartnerId = location?.state?.recruiterPartnerId;
  const recruitmentpartnerId =
    recruiterPartnerId ||
    location?.state?.recruitmentpartnerId ||
    userRecruitmentpartnerId;
  const userId = location.state?.userId;
  const isVet = location.state?.isVet || false;

  const handleSubmit = async () => {
    if (rating === 0) {
      return NotificationManager.error(
        "Please provide a rating before submitting",
        "Error",
        10000
      );
    }
    if (userId) {
      const payload = isVet
      ? {
          vetCandidateTestId: userId,
          rating: rating,
          comment: comment,
          isVet: true,
          recruitmentpartnerId,
        }
      : {
          userid: userId,
          rating: rating,
          comment: comment,
          recruitmentpartnerId,
        };
      
      
      await aiTestRating(payload)
      setTimeout(() => {
        navigate("/referral", {
          replace: true,
          state: { recruiterPartnerId }
        });
      }, 1500);
      setIsSubmitted(true);
    }
  };

  return (
    <ThankYouContent
      rating={rating}
      setRating={setRating}
      comment={comment}
      setComment={setComment}
      handleSubmit={handleSubmit}
      isSubmitted={isSubmitted}
      showHeader={true}
    />
  );
}
